import { render, staticRenderFns } from "./CrosswordClueEntry.vue?vue&type=template&id=7135157e&scoped=true"
import script from "./CrosswordClueEntry.vue?vue&type=script&lang=js"
export * from "./CrosswordClueEntry.vue?vue&type=script&lang=js"
import style0 from "./CrosswordClueEntry.vue?vue&type=style&index=0&id=7135157e&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7135157e",
  null
  
)

export default component.exports